/*global AmCharts, App */

Components.Energy.Common.Histogram = function (id, loadDataLink, mode, phase) {
    phase = parseInt(phase);
    phase--;
    if (phase < 0 || phase > 2) phase = 3;
    /* private */
    var _containerVoltage = id + "_voltage";
    var _containerCurrent = id + "_current";
    var _exportButton = document.getElementById(id + "_button");
    var colors = [App.Ui.getColors()[phase]];
    var _chartVoltage;
    var _chartCurrent;
    var prepareDataForChart = function (rawData) {
        // Voltage
        var countage = 0;
        var dataProvider = [];
        for (var key in rawData.voltage.categories) {
            if (rawData.voltage.values[key] > 0)
                countage++;
            dataProvider.push({category: rawData.voltage.categories[key], value: rawData.voltage.values[key]});
        }
        if (dataProvider.length === 0) {
            App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
        } else {
            if (countage < 2 && _chartVoltage.valueAxes[0]) _chartVoltage.valueAxes[0].logarithmic = false;
            _chartVoltage.dataProvider = dataProvider;
            _chartVoltage.validateData();
        }
        // Current
        var countage = 0;
        var dataProvider = [];
        for (var key in rawData.current.categories) {
            if (rawData.current.values[key] > 0)
                countage++;
            dataProvider.push({category: rawData.current.categories[key], value: rawData.current.values[key]});
        }
        if (dataProvider.length === 0) {
            App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
        } else {
            if (countage < 2 && _chartCurrent.valueAxes[0]) _chartCurrent.valueAxes[0].logarithmic = false;
            _chartCurrent.dataProvider = dataProvider;
            _chartCurrent.validateData();
        }
    };
    var loadData = function () {
        App.Ui.widgetBlock($("#" + _containerVoltage));
        App.Ui.widgetBlock($("#" + _containerCurrent));
        $.ajax({
            type: "post",
            data: {mode: mode, phase: (phase + 1)},
            dataType: "json",
            url: loadDataLink,
            complete: function () {
                App.Ui.widgetBlock($("#" + _containerVoltage), "stop");
                App.Ui.widgetBlock($("#" + _containerCurrent), "stop");
            },
            success: function (result) {
                if (typeof result.voltage === "undefined" || typeof result.current === "undefined") {
                    App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
                } else {
                    prepareDataForChart(result);
                }
            },
            error: function () {
                App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
            }
        });
    };
    var createChart = function () {
        _chartVoltage = new AmCharts.AmSerialChart();
        _chartVoltage.colors = colors;
        _chartVoltage.language = "cz";
        _chartVoltage.pathToImages = "/dist/amcharts/images/";
        _chartVoltage.export = App.Charts.export;
        _chartVoltage.dataProvider = [];
        _chartVoltage.categoryField = "category";
        _chartVoltage.zoomOutText = "Oddálit";
        _chartVoltage.zoomOutButtonPadding = 25;
        _chartVoltage.autoMargins = false;
        _chartVoltage.marginLeft = 80;
        _chartVoltage.marginBottom = 40;
        _chartVoltage.allLabels = [{
            text: "Napětí [V]",
            bold: true,
            x: "50%",
            y: 0
        }];
        var graph = new AmCharts.AmGraph();
        graph.id = "g1";
        graph.valueField = "value";
        graph.type = "column";
        graph.columnWidth = 0.75;
        graph.fillAlphas = 0.9;
        graph.showBalloon = true;
        graph.balloonText = "<b>[[value]]s</b> ([[category]]V)";
        graph.valueAxis = "va1";
        _chartVoltage.addGraph(graph);
        var valueAxis = new AmCharts.ValueAxis();
        valueAxis.id = "va1";
//            valueAxis.inside = true;
//            valueAxis.showFirstLabel = false;
        valueAxis.unit = "s";
//            valueAxis.title = "Čas [s]";
        valueAxis.logarithmic = true;
        _chartVoltage.addValueAxis(valueAxis);
        var chartCursor = new AmCharts.ChartCursor();
        chartCursor.categoryBalloonEnabled = true;
        chartCursor.categoryBalloonText = "[[category]]V";
        chartCursor.cursorAlpha = 0.05;
        chartCursor.fullWidth = true;
        chartCursor.zoomable = true;
        _chartVoltage.chartCursor = chartCursor;
        var categoryAxis = new AmCharts.CategoryAxis();
        categoryAxis.id = "ca1";
        categoryAxis.unit = "V";
        _chartVoltage.categoryAxis = categoryAxis;

        _chartVoltage.write(_containerVoltage);

        _chartCurrent = new AmCharts.AmSerialChart();
        _chartCurrent.colors = colors;
        _chartCurrent.language = "cz";
        _chartCurrent.pathToImages = "/dist/amcharts/images/";
        _chartCurrent.export = App.Charts.export;
        _chartCurrent.dataProvider = [];
        _chartCurrent.categoryField = "category";
        _chartCurrent.zoomOutText = "Oddálit";
        _chartCurrent.zoomOutButtonPadding = 25;
        _chartCurrent.columnSpacing = 0;
        _chartCurrent.autoMargins = false;
        _chartCurrent.marginLeft = 80;
        _chartCurrent.marginBottom = 40;
        _chartCurrent.allLabels = [{
            text: "Proud [A]",
            bold: true,
            x: "50%",
            y: 0
        }];
        var graph2 = new AmCharts.AmGraph();
        graph2.id = "g2";
        graph2.valueField = "value";
        graph2.type = "column";
        graph2.columnWidth = 0.75;
        graph2.fillAlphas = 0.9;
        graph2.showBalloon = true;
        graph2.balloonText = "<b>[[value]]s</b> ([[category]]A)";
        graph2.valueAxis = "va2";
        _chartCurrent.addGraph(graph2);
        var valueAxis2 = new AmCharts.ValueAxis();
        valueAxis2.id = "va2";
//            valueAxis2.inside = true;
//            valueAxis2.showFirstLabel = false;
        valueAxis2.unit = "s";
//            valueAxis2.title = "Čas [s]";
        valueAxis2.logarithmic = true;
        _chartCurrent.addValueAxis(valueAxis2);
        var chartCursor2 = new AmCharts.ChartCursor();
        chartCursor2.categoryBalloonEnabled = true;
        chartCursor2.categoryBalloonText = "[[category]]A";
        chartCursor2.cursorAlpha = 0.05;
        chartCursor2.fullWidth = true;
        chartCursor2.zoomable = true;
        _chartCurrent.chartCursor = chartCursor2;
        var categoryAxis2 = new AmCharts.CategoryAxis();
        categoryAxis2.id = "ca2";
        categoryAxis2.unit = "A";
        _chartCurrent.categoryAxis = categoryAxis2;

        _chartCurrent.write(_containerCurrent);

        loadData();
    };
    var exportCharts = function () {
        var images = [];
        var charts = [_chartVoltage, _chartCurrent];
        var pending = charts.length;
        for (var i = 0; i < pending; i++) {
            var chart = charts[i];
            chart.export.capture({}, function () {
                this.toJPG({}, function (data) {
                    images.push({
                        "image": data,
                        "fit": [780, 500]
                    });
                    pending--;
                    if (pending === 0) {
                        // all done - construct PDF
                        chart.export.toPDF({
                            content: images,
                            pageOrientation: "landscape"
                        }, function (data) {
                            this.download(data, "application/pdf", "Histogram.pdf");
                        });
                    }
                });
            });
        }
    };
    /* public */
    /* contructor */
    createChart();
    _exportButton.onclick = exportCharts;
};
